import { render, staticRenderFns } from "./NotesLinkedQuestions.vue?vue&type=template&id=d86d3a48&scoped=true"
import script from "./NotesLinkedQuestions.vue?vue&type=script&lang=js"
export * from "./NotesLinkedQuestions.vue?vue&type=script&lang=js"
import style0 from "./NotesLinkedQuestions.vue?vue&type=style&index=0&id=d86d3a48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86d3a48",
  null
  
)

export default component.exports